import { useEffect } from 'react';

const useResetFiltersBeforeUnload = (callBack) => {
  useEffect(() => {
    const handleBeforeUnload = () => {
      callBack();
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [callBack]);
};

export default useResetFiltersBeforeUnload;
